import Input from '@/src/components/Antd/Input/Input';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import React from 'react';
import { Tag } from 'src/components/Tags/Tags';
// import { Form } from 'src/components/Antd';
// const Item = Form.Item;
const InputWithTags = (props) => {
  const { value, onChange, id, title, subtitle, placeholder, duplicateError } =
    props;
  const [v, setV] = React.useState('');
  const [err, setErr] = React.useState(null);
  const [tags, setTags] = React.useState(value || []);
  React.useEffect(() => {
    if (value && value !== tags) {
      setTags(value);
    }
  }, [value]);
  const handleOnEnter = () => {
    if (!v) {
      setErr('Value cannot be empty');
    } else if ((tags || []).find((i) => i === v)) {
      setErr(duplicateError || 'Value cannot be duplicated');
    } else {
      const t = [...(tags || []), v];
      setTags(t);
      if (onChange) {
        onChange(t);
      }
      setV('');
    }
  };
  const handleOnClose = (index) => {
    const t = [...(tags || [])];
    t.splice(index, 1);
    setTags(t);
    if (onChange) {
      onChange(t);
    }
  };

  const handleChange = (v) => {
    const regBreak = /[,｜\s｜，|,]+/g;
    const arr = v?.split(regBreak) || [];
    if (arr.length <= 1) {
      setV(v);
      setErr(null);
    } else {
      const trimmedArr = arr.filter((v) => !!v);
      const t = [...new Set([...(tags || []), ...trimmedArr])];
      setTags(t);
      if (onChange) {
        onChange(t);
      }
      setV('');
    }
  };

  return (
    <ItemWrapper
      title={title || 'Tags'}
      rightSubTitle={subtitle || 'Press enter to add tag'}
      id={id}>
      <Input
        maxLength={50}
        size='large'
        placeholder={placeholder || 'Add new tag'}
        value={v}
        onChange={handleChange}
        onPressEnter={handleOnEnter}
        error={err}
        help={err}
        //disabled={disabled}
      />
      <div>
        {tags.map((item, index) => (
          <Tag
            index={index}
            key={item}
            // disabled={disabled}
            onClose={() => {
              handleOnClose(index);
            }}>
            {item}
          </Tag>
        ))}
      </div>
    </ItemWrapper>
  );
};
export default InputWithTags;
